import { WebsiteLanguage } from '../i18n';

/** A visitor with no recognised preference reads the English site. */
export const DEFAULT_LANGUAGE = WebsiteLanguage.English;

// Slovak visitors get the Czech site: there is no `sk` translation and the two
// are mutually intelligible.
const CZECH_SUBTAGS: ReadonlySet<string> = new Set(['cs', 'sk']);

/**
 * Pick the site language for a visitor from the language tags they accept.
 *
 * Any cs/sk preference wins regardless of where it sits in the list or what
 * q-value it carries - that is what `req.acceptsLanguages(['cs', 'sk'])` did
 * for the `/` redirect before this helper existed, and both entry points
 * (Express and the router) have to agree or the same visitor would land in a
 * different language depending on which layer answered.
 *
 * @param acceptedTags language tags in any order, e.g. `['cs-CZ', 'en;q=0.8']`
 */
export function negotiateLanguage(
  acceptedTags: readonly string[],
): WebsiteLanguage {
  return acceptedTags.some(tag => CZECH_SUBTAGS.has(primarySubtag(tag)))
    ? WebsiteLanguage.Czech
    : DEFAULT_LANGUAGE;
}

/**
 * Split a raw `Accept-Language` header into tags for {@link negotiateLanguage}.
 * Express parses the header itself (`req.acceptsLanguages()`); this is for the
 * SSR `REQUEST` token, which hands over the raw string.
 */
export function acceptedLanguageTags(
  header: string | null | undefined,
): string[] {
  return header ? header.split(',') : [];
}

function primarySubtag(tag: string): string {
  return tag.trim().toLowerCase().split(/[-;]/, 1)[0];
}
